/**
 * Automatic Discount Display - Simple Event Listener
 *
 * Listens for variant price changes and applies discount based on product tags
 * (e.g., _discount_25 for 25% off)
 *
 * @version 2.0 - Simplified
 */

(function() {
  'use strict';

  // Function to update price with discount
  function updateDiscountPrice(container, variant) {
    var priceElement = container.querySelector('[data-product-price]');
    if (!priceElement) return;

    var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
    if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) return;

    var autoDiscountWrap = container.querySelector('[data-auto-discount-wrap]');
    var autoDiscountOriginal = container.querySelector('[data-auto-discount-original]');
    var autoDiscountSavings = container.querySelector('[data-auto-discount-savings]');

    console.log('💰 Applying discount:', autoDiscountPercent + '%', 'to price:', variant.price);

    // Check if there's a regular sale first (compare_at_price)
    if (variant.compare_at_price > variant.price) {
      console.log('⚠️ Product already on sale, skipping automatic discount');
      // Hide automatic discount elements
      if (autoDiscountWrap) autoDiscountWrap.classList.add('hide');
      if (autoDiscountSavings) autoDiscountSavings.classList.add('hide');
      return;
    }

    // Calculate discounted price
    var discountMultiplier = (100 - parseFloat(autoDiscountPercent)) / 100;
    var discountedPrice = variant.price * discountMultiplier;

    console.log('✅ Discounted price:', discountedPrice);

    // Update price display
    priceElement.innerHTML = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
    priceElement.classList.add('on-sale');

    // Show/update original price
    if (autoDiscountOriginal) {
      autoDiscountOriginal.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    }
    if (autoDiscountWrap) {
      autoDiscountWrap.classList.remove('hide');
    }

    // Calculate and show savings
    var savings = variant.price - discountedPrice;
    if (theme.settings.saveType === 'percent') {
      savings = autoDiscountPercent + '%';
    } else {
      savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
    }

    if (autoDiscountSavings && theme.strings.savePrice) {
      autoDiscountSavings.classList.remove('hide');
      autoDiscountSavings.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
    }

    // Update Recharge widget with the same variant price
    var productContainer = container.closest('[data-section-type="product"]');
    if (productContainer) {
      updateRechargeWidget(productContainer, variant, autoDiscountPercent, false);
    }
  }

  // Function to update Recharge widget price
  function updateRechargeWidget(container, variant, autoDiscountPercent, isPageLoad) {
    if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) {
      return;
    }

    // Skip if product is already on sale (only if we have variant data)
    if (variant && variant.price > 0 && variant.compare_at_price > variant.price) {
      return;
    }

    // Find the Recharge widget container (the empty div that will be populated)
    var rechargeContainer = container.querySelector('[id^="RechargeWidget_"]');
    if (!rechargeContainer) {
      console.log('DEBUG: Recharge container not found');
      return;
    }

    var discountMultiplier = (100 - parseFloat(autoDiscountPercent)) / 100;
    var variantPrice = variant && variant.price > 0 ? variant.price : null;

    // Only delay on page load, variant changes update immediately
    var delay = isPageLoad ? 2000 : 0;

    if (isPageLoad) {
      console.log('DEBUG: Page load - waiting 2 seconds for Recharge to fully render. Variant price:', variantPrice);
    } else {
      console.log('🔄 Variant change - updating Recharge widget immediately. Variant price:', variantPrice);
    }

    // Wait for Recharge to fully render (only on page load), then directly update price
    setTimeout(function() {
      console.log('DEBUG: Looking for price elements in Recharge widget...');

      // Try multiple selectors to find the one-time price element
      var priceSelectors = [
        'label[for*="onetime"] span',
        '[class*="onetime"] [class*="price"]',
        'input[type="radio"][value=""] + label span',
        '[class*="radio"]:first-child span',
        'label span',
        'span'
      ];

      var onetimeLabel = null;
      for (var i = 0; i < priceSelectors.length; i++) {
        var elements = rechargeContainer.querySelectorAll(priceSelectors[i]);
        console.log('DEBUG: Trying selector "' + priceSelectors[i] + '", found', elements.length, 'elements');
        // Look for element that contains a price format ($ or number)
        for (var j = 0; j < elements.length; j++) {
          if (elements[j].textContent.includes('$') || /\d/.test(elements[j].textContent)) {
            onetimeLabel = elements[j];
            console.log('✅ Found price element with selector:', priceSelectors[i], 'text:', elements[j].textContent);
            break;
          }
        }
        if (onetimeLabel) break;
      }

      if (onetimeLabel && theme.Currency) {
        var discountedPrice;

        // If we have variant price from event, use it
        if (variantPrice) {
          discountedPrice = variantPrice * discountMultiplier;
          console.log('DEBUG: Using variant price:', variantPrice, '→', discountedPrice);
        } else {
          // On page load, parse the price from Recharge's display and apply discount
          var rechargePrice = onetimeLabel.textContent.replace(/[^0-9.]/g, '');
          var priceInCents = parseFloat(rechargePrice) * 100;
          discountedPrice = priceInCents * discountMultiplier;
          console.log('DEBUG: Parsed Recharge price:', rechargePrice, '→', priceInCents, '→', discountedPrice);
        }

        var formattedPrice = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
        console.log('DEBUG: Updating price from', onetimeLabel.textContent, 'to', formattedPrice);
        onetimeLabel.textContent = formattedPrice;
        console.log('✅ Recharge widget price updated successfully');
      } else {
        console.log('❌ Could not find price element in Recharge widget');
        console.log('DEBUG: Widget HTML:', rechargeContainer.innerHTML.substring(0, 500));
      }
    }, delay); // Delay only on page load
  }

  // Initialize on page load
  function init() {
    console.log('🚀 Automatic Discount: Initializing...');

    // Find all product containers
    var productContainers = document.querySelectorAll('[data-section-type="product"]');
    console.log('🔍 Found', productContainers.length, 'product containers');

    productContainers.forEach(function(container) {
      console.log('📍 Page load: Setting up Recharge widget watcher...');

      // Simple retry - just wait for Recharge div to appear
      var attempts = 0;
      var maxAttempts = 20;

      var checkForRecharge = setInterval(function() {
        attempts++;
        var rechargeContainer = container.querySelector('[id^="RechargeWidget_"]');

        if (rechargeContainer) {
          console.log('✅ Recharge widget div found!');
          clearInterval(checkForRecharge);

          // Get discount percent and variant
          var priceElement = container.querySelector('[data-product-price]');
          var autoDiscountPercent = priceElement ? priceElement.dataset.autoDiscountPercent : null;

          console.log('DEBUG: Discount percent:', autoDiscountPercent);

          if (autoDiscountPercent && parseFloat(autoDiscountPercent) > 0) {
            console.log('DEBUG: Calling updateRechargeWidget for page load');
            // Create a minimal variant object - updateRechargeWidget will get the price from Recharge itself
            updateRechargeWidget(container, { price: 0, compare_at_price: 0 }, autoDiscountPercent, true);
          }
        } else if (attempts >= maxAttempts) {
          console.log('⏱️ Recharge widget not found after 10 seconds');
          clearInterval(checkForRecharge);
        }
      }, 500);


      // Listen for variant price changes
      container.addEventListener('variantPriceChange', function(event) {
        console.log('🔄 Variant price changed!', event.detail.variant);
        updateDiscountPrice(container, event.detail.variant);
      });

      // Also listen for variantChange to update Recharge widget
      container.addEventListener('variantChange', function(event) {
        var variant = event.detail.variant;
        if (!variant) return;

        var priceElement = container.querySelector('[data-product-price]');
        if (priceElement) {
          var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
          updateRechargeWidget(container, variant, autoDiscountPercent, false);
        }
      });
    });

    console.log('✅ Automatic Discount: Ready!');
  }

  // Wait for page to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
